import React from "react";

const PEOPLE = [
  { name: "Carissa", emoji: "👩", bg: "#E8DDD4" },
  { name: "Robert",  emoji: "👨", bg: "#D4E0E8" },
  { name: "Adam",    emoji: "🏊", bg: "var(--sage-muted)" },
  { name: "Kimberly",emoji: "💃", bg: "var(--rose-muted)" },
];

export default function AvatarStrip({ onAvatarTap }) {
  return (
    <div style={{
      background: "var(--white)",
      padding: "14px 20px 16px",
      display: "flex",
      gap: 20,
      alignItems: "center",
      borderBottom: "2px solid var(--border)",
      overflowX: "auto",
      scrollbarWidth: "none",
    }}>
      {PEOPLE.map((p) => (
        <div key={p.name}
          onClick={() => onAvatarTap?.(p.name)}
          style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6, cursor: "pointer", flexShrink: 0 }}
        >
          <div style={{ width: 54, height: 54, borderRadius: "50%", border: "2.5px solid var(--border)", padding: 2 }}>
            <div style={{ width: "100%", height: "100%", borderRadius: "50%", background: p.bg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 }}>
              {p.emoji}
            </div>
          </div>
          <div style={{ fontSize: 12, fontWeight: 700, color: "var(--muted)" }}>{p.name}</div>
        </div>
      ))}
    </div>
  );
}
